import { configureStore } from "@reduxjs/toolkit"
import { createLogger } from 'redux-logger'

import reducer from "./reducer"

const logger = createLogger({
  collapsed: true,
  level: 'info',
});

const middleware = [];
if (process.env.NODE_ENV === `development`) {
  // Note: Logger must be the last middleware in the chain
  middleware.push(logger);
}

const store = configureStore({ reducer, middleware })

export default store
